// extracted by mini-css-extract-plugin
export default {"base":"vp_sL_44","wrapper":"vp_EU_KK","alignLeft":"vp_jYZBW"};